/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import { permissionObj } from '../../../../../Helpers/permission';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import { EditIcon } from "../../../../../components/buttons/IconButtons";
import { EmployeeFlowContractorUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/EmployeeFlowContractorUpdateApp";
import { CommonContractorCreateUpdateApp } from "../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import ContractorCompanyFields from "./ContractorCompanyFields";
import ManagerFields from "./ManagerFields";
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import AccessRights from '../../../Company/Employees/AccessRightsSection/AccessRights';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import {STEPS_CONTRACTOR_UPDATE} from "../../Model/Models";
import { validateMinLengthTrimmed } from '../../../../../Apis/functions';
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';

const EmployeeFlowContractorUpdate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        params,
        permission,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        isValidPassword,
        setIsValidPassword,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        modified,
        setModified
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack
    } = EmployeeFlowContractorUpdateApp({
        t,
        params,
        dispatch,
        navigate,
        workShiftsList,
        customizedList,
        setEmptyFields,
        isValidDob,
        isValidPassword,
        photoPicker,
        permission,
        setWorkShiftsList,
        setCustomizedList,
        setSecretModal,
        setSecretKey,
        setSteps,
        modified,
        setModified,
        setPhotoPicker
    });


    if (!DEV &&
        (!permission?.includes(permissionObj.WEB_CONTRACTOR_READ) ||
            !permission?.includes(permissionObj.WEB_CONTRACTOR_UPDATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle onBack={goBack} name={t('update')}>
                {(DEV || permission?.includes(permissionObj.WEB_CONTRACTOR_UPDATE)) && (
                    <ButtonAction
                        id={'btn_efcu_update'}
                        name={'update'}
                        className={'btn-icon-edit'}
                        disabled={false}
                        Icon={EditIcon}
                        onClick={() => {
                            validateEmail(user.email);
                            validatePhone(user.phoneNumber);
                            const isValid = validateMinLengthTrimmed(user.password, {
                                minLength: PASSWORD_MIN_LENGTH,
                                allowEmpty: true,
                            });
                            setIsValidPassword(isValid);

                            if (!isValid) return;
                            FormHandler();
                        }}
                    />
                )}
            </HeadTittle>
            <StepperTabs id={user?.id} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={step => step === 1}
                setActiveStep={setActiveStep} handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CONTRACTOR_UPDATE.COMPANY_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_UPDATE.COMPANY_DETAILS &&
                        <ContractorCompanyFields
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            getAllServiceType={getAllServiceType}
                        />
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_UPDATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_UPDATE.MANAGER_DETAILS &&
                        <ManagerFields
                            title={"manager"}
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            isValidDocumentId={isValidDocumentId}
                            setIsValidDocumentId={setIsValidDocumentId}
                            isValidEmail={isValidEmail}
                            isValidPhoneNumber={isValidPhoneNumber}
                            isValidDob={isValidDob}
                            setIsValidDob={setIsValidDob}
                            handleEmailChange={handleEmailChange}
                            handlePasswordChange={handlePasswordChange}
                            handlePhoneNumberChange={handlePhoneNumberChange}
                            handleDateChange={handleDateChange}
                            statusList={userInfoStatusList}
                        />
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_UPDATE.ADD_PHOTO} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_UPDATE.ADD_PHOTO &&
                        <CustomPhotoPicker
                            id='fp_ce_update_photo_profile'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.UPDATE}
                            accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                            showBtnCamera={true}
                            validateFace={true}
                            classWith={'w-400px'}
                            showPreview={true}
                            disabled={disabled}
                            titleModalEdit='update_photography'
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                        />
                    }
                </StepTab>
                <StepTab index={STEPS_CONTRACTOR_UPDATE.ACCESS_RIGHT} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_CONTRACTOR_UPDATE.ACCESS_RIGHT &&
                        <AccessRights
                            workShiftsList={workShiftsList}
                            setWorkShiftsList={setWorkShiftsList}
                            customizedList={customizedList}
                            setCustomizedList={setCustomizedList}
                            user={user}
                            contractorItemId={params?.id}
                            isEditable={true}
                        />
                    }
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />

        </>
    );
};

export default EmployeeFlowContractorUpdate;
